// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bl-token-attribute-group-label{font-weight:600;align-self:center}", "",{"version":3,"sources":["webpack://./src/components/cql/CqlAddAttributeButton.vue"],"names":[],"mappings":"AAEA,gCACC,eAAA,CACA,iBAAA","sourcesContent":["\n\n.bl-token-attribute-group-label {\n\tfont-weight: 600;\n\talign-self: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
